module.exports = __webpack_public_path__ + "media/fonts/CircularStd-Medium-06dce1b52a24a6dfe3a263efae4acc9f.woff2";